import { Grid, Typography,Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { GetLocation } from 'src/utils/Common';
import { useTranslation } from 'react-i18next';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const useStyles = makeStyles((theme) => ({
  root: {},
  info: {
    marginTop: theme.spacing(1)
  },
  IconTop: {
    paddingTop: 1,
  }
}));

function Header(
  {
    className, ReceiptNo, tasks
  }
) {
  const classes = useStyles();
  const [durum, setDurum] = React.useState('');
  const [basvuruNedeni, setbasvuruNedeni] = React.useState('');
  const [FisHeader, setFisHeader] = useState(tasks.tasks.filter((d) => parseInt(d.ReceiptNo, 10) === parseInt(ReceiptNo, 10)));
  const history = useHistory();
  const { t } = useTranslation('work_order');

  const handleBack = () => {
    history.goBack(); 
  };


  useEffect(() => {
    GetLocation();
    const current = tasks.tasks.filter((d) => parseInt(d.ReceiptNo, 10) === parseInt(ReceiptNo, 10));
    setFisHeader(current);
    if (current.length > 0) {
      setDurum(current[0].Status);
      setbasvuruNedeni(current[0].IssueReason);
    }
    // eslint-disable-next-line
  }, [tasks.tasks]);


  return (
    !FisHeader[0] ? <></>
      : (
        <div className={clsx(classes.root, className)}>
          <Grid container alignItems="flex-end" justifyContent="space-between" spacing={3}>
            <Grid item xs={8} sm={6} lg={6}>
              <Typography variant="h6" gutterBottom>
                {FisHeader[0].CustomerFullName}
                {', '}
                {FisHeader[0].ReceiptNo}
                {', '}
                {durum}
                {/* {FisHeader[0]?.ExternalId == null ? '' : ', SF: ' + FisHeader[0]?.ExternalId} */}
              </Typography>
              <Typography variant="body2" gutterBottom>
                {basvuruNedeni}
                <br />
              </Typography>
            </Grid>
            <Grid item xs={2} sm={2} lg={2} className={classes.IconTop}>
              <Typography variant="h6" gutterBottom>
                {(parseInt(FisHeader[0].NumberOfComments) === 0) ? ''
                  : <FaWhatsapp onClick={() => history.push(`/WorkOrder/${FisHeader[0].ReceiptNo}/Yorum`)} style={{ color: '#1D3343' }} size="30" />}
              </Typography>
            </Grid>
            <Grid item xs={4} sm={4} lg={4} style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={handleBack}
                variant="contained"
                color="primary"
                startIcon={<ArrowBackIcon />}
              >
                {t('lblBack')}
              </Button>
            </Grid>
          </Grid>
        </div>
      )

  );
}


export default connect(
  (state) => ({ tasks: state.tasks1 })
)(Header);
